import {GetBreadcrumbsError} from './GetBreadcrumbsError.js'

export class BreadcrumbErrorsFactory {
  static getBreadcrumbs = msg => new GetBreadcrumbsError(msg)
}
